import { FirmaElectronicaComponent } from "components/componentesGenerales/firmaElectronica";
import { ValidateStatus } from "components/componentesGenerales/firmaElectronica/interfaces/firmaInterfaces";
import { useDemandaStore } from "hooks/useDemandaStore";

interface FirmanteInterfaceProps {
  statusFirma: ValidateStatus;
}
export const Firmante = ({ statusFirma }: FirmanteInterfaceProps) => {
  const { solicitudDemandaRes } = useDemandaStore();
  return (
    <FirmaElectronicaComponent.Firmante
      size="small"
      rules={{
        required: {
          value: true,
          message: "Selecciona almenos una opción",
        },
      }}
      disabled={
        solicitudDemandaRes?.isCompletedProcess &&
        statusFirma?.signed?.length &&
        statusFirma?.signed[0]?.data?.length
          ? true
          : false
      }
    />
  );
};
